(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* === 🌈 Final Header Style: White Bold & Horizontal === */
document.addEventListener('DOMContentLoaded', () => {
  const white = '#ffffff';
  const dark = '#222222';
  const green = '#3A8735';
  const header = document.querySelector('.header, header');
  const links = document.querySelectorAll('.header-menu a, .menu-list__item a');

  const style = document.createElement('style');
  style.textContent = `
    /* === MENU LAYOUT === */
    .header__inline-menu {
      display: flex !important;
      flex-direction: row !important;
      justify-content: center;
      align-items: center;
      gap: 34px !important;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .menu-list__item {
      display: inline-block !important;
    }

    /* === BASE LINK STYLE === */
    .header-menu a,
    .menu-list__item a {
      font-family: 'Host Grotesk', sans-serif !important;
      font-weight: 600 !important; /* BOLD */
      font-size: 16px !important;
      text-decoration: none !important;
      letter-spacing: 0.3px;
      transition: color 0.3s ease;
      position: relative;
      display: inline-block;
      padding: 10px 5px;
    }

    /* Underline hover animation */
    .header-menu a::after,
    .menu-list__item a::after {
      content: '';
      position: absolute;
      left: 0; bottom: 2px;
      width: 100%; height: 1px;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.25s ease, background-color 0.25s ease;
    }
    .header-menu a:hover::after,
    .menu-list__item a:hover::after {
      transform: scaleX(1);
      background-color: ${green} !important;
    }
  `;
  document.head.appendChild(style);

  const isHome =
    window.location.pathname === '/' ||
    document.body.classList.contains('template-index') ||
    document.body.dataset.template?.includes('index');

  // Helper to apply color
  const setLinkColor = (color) => {
    links.forEach((link) => {
      link.style.color = color;
      link.style.setProperty('color', color, 'important');
    });
  };

  // === HOME LOGIC (white over video, dark on scroll) ===
  if (isHome) {
    setLinkColor(white);

    const observer = new MutationObserver(() => {
      const bg = window.getComputedStyle(header).backgroundColor;
      const isTransparent = !bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent';
      if (isTransparent) {
        setLinkColor(white);
      } else {
        setLinkColor(dark);
      }
    });
    if (header) {
      observer.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY < 100) setLinkColor(white);
      else setLinkColor(dark);
    });
  } else {
    setLinkColor(dark);
  }

  // Hover green
  links.forEach((link) => {
    link.addEventListener('mouseenter', () =>
      link.style.setProperty('color', green, 'important')
    );
    link.addEventListener('mouseleave', () => {
      if (isHome && window.scrollY < 100) setLinkColor(white);
      else setLinkColor(dark);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
